import clsx from 'clsx';
import Style from './radioGroupField.module.scss';
import { AppRadioGroupInput } from 'uikit/inputs';
import { BuilderFieldError, BuilderFieldErrorProps } from '../../wrappers/error/builderFieldError.component';
import { BuilderFieldLabel, BuilderFieldLabelProps } from '../../wrappers/label/builderFieldLabel.component';
import { AppRadioGroupInputProps } from 'uikit/inputs/radio/appRadioGroupInput';

export type AppRadioGroupFieldProps<TOption, TKey extends string | number = string | number> = {
  labelProps: BuilderFieldLabelProps;
  errorProps?: BuilderFieldErrorProps;
} & AppRadioGroupInputProps<TOption, TKey>;

export function AppRadioGroupField<TOption, TKey extends string | number = string | number>({
  errorProps,
  labelProps,
  disabled,
  ...rest
}: AppRadioGroupFieldProps<TOption, TKey>) {
  return (
    <BuilderFieldError {...errorProps}>
      <BuilderFieldLabel className={clsx(Style.labelContainer)} disabled={disabled} {...labelProps}>
        <AppRadioGroupInput disabled={disabled} {...rest} />
      </BuilderFieldLabel>
    </BuilderFieldError>
  );
}
